module.exports = __webpack_public_path__ + "img/marketplace_YT.2ec48f3f.svg";